import React from "react";
import { Security } from "@okta/okta-react";
import { UserProvider, oktaAuth } from "../contexts/UserContext";
import { AlertsProvider } from "../contexts/AlertsContext";
import HttpInterceptor from "../api/HttpInterceptor";
import { BCR } from "best-common-react";
import { BCR as BCR3, Midnight as MidnightTheme } from "best-common-react-3";
import { DropdownsProvider } from "../contexts/DropdownContext";
import { SseNotificationProvider } from "../contexts/SseNotificationContext";
import Midnight from "../theme/Midnight";

const WrapperProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string): Promise<void> => {
    window.location.replace(originalUri);
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <UserProvider>
        <HttpInterceptor>
          <SseNotificationProvider>
            <AlertsProvider>
              <DropdownsProvider>
                <BCR3 theme={MidnightTheme}>
                  <BCR theme={Midnight}>{children}</BCR>
                </BCR3>
              </DropdownsProvider>
            </AlertsProvider>
          </SseNotificationProvider>
        </HttpInterceptor>
      </UserProvider>
    </Security>
  );
};

export default WrapperProvider;
